/* dn-code-guard.js — Serené · Día de la Novia (v4)
   Fuera del builder DN y de /cart: barre el codigo NOVIA2DA-SERENE (SIEMPRE que
   este aplicado; {discount:''} no toca automaticos) y las lineas _dn_novia, en
   DOS llamadas. Re-barre tras CADA mutacion del carrito (fetch Y XHR) porque los
   kit-builders agregan items en su propia pagina. Refresca el drawer al final. */
(function () {
  'use strict';
  if (window.__dnGuardLoaded) return;
  window.__dnGuardLoaded = true;
  var DN_CODE = 'NOVIA2DA-SERENE';
  var p = (location.pathname || '').replace(/\/+$/, '');
  var onDnPage = !!document.querySelector('[data-dn-step]');
  var onCart = /(^|\/)cart$/.test(p);
  if (onDnPage || onCart) return;
  function post(body) {
    return fetch('/cart/update.js', { method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body) });
  }
  function refreshCartUI() {
    return fetch('/?sections=cart-icon-bubble,cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sec) {
        try {
          if (sec['cart-icon-bubble']) {
            var pB = new DOMParser().parseFromString(sec['cart-icon-bubble'], 'text/html');
            var tB = document.getElementById('cart-icon-bubble');
            var sB = pB.querySelector('#shopify-section-cart-icon-bubble') || pB.querySelector('.shopify-section');
            if (tB && sB) tB.innerHTML = sB.innerHTML;
          }
          if (sec['cart-drawer']) {
            var pD = new DOMParser().parseFromString(sec['cart-drawer'], 'text/html');
            var tD = document.querySelector('cart-drawer');
            var sD = pD.querySelector('cart-drawer');
            if (tD && sD) { tD.classList.toggle('is-empty', sD.classList.contains('is-empty')); tD.innerHTML = sD.innerHTML; }
          }
        } catch (e) {}
      }).catch(function () {});
  }
  function sweep() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var apps = (cart && cart.cart_level_discount_applications) || [];
        var mine = apps.some(function (a) { return a && a.title === DN_CODE; });
        var updates = {};
        (cart.items || []).forEach(function (li) { if (li.properties && li.properties._dn_novia) updates[li.key] = 0; });
        var hasLines = Object.keys(updates).length > 0;
        if (!mine && !hasLines) return;
        var chain = Promise.resolve();
        if (mine) chain = chain.then(function () { return post({ discount: '' }); });
        if (hasLines) chain = chain.then(function () { return post({ updates: updates }); });
        return chain.then(function () { return refreshCartUI(); });
      }).catch(function () {});
  }
  sweep();
  function isCartMut(url) { return typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url); }
  try {
    var of = window.fetch;
    window.fetch = function () {
      var url = (arguments[0] && arguments[0].url) || arguments[0] || '';
      var pr = of.apply(this, arguments);
      if (isCartMut(url)) pr.then(function () { setTimeout(sweep, 250); }).catch(function () {});
      return pr;
    };
  } catch (e) {}
  try {
    var oo = XMLHttpRequest.prototype.open, osend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, url) { this.__dnUrl = url; return oo.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      if (isCartMut(this.__dnUrl)) this.addEventListener('loadend', function () { setTimeout(sweep, 250); });
      return osend.apply(this, arguments);
    };
  } catch (e) {}
})();
